export class Contratista {

    public id?: number;
    public rut?: number;
    public nombre_corto?: string;
    public razon_social?: string;
}
